import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { RouteProps } from 'react-router';
import { connect } from 'react-redux';

import Path from '@utils/Path';
import { ApplicationState } from 'reducers';

type Props = {
    isLoggedIn: boolean,
} & RouteProps;

class GuestRoute extends React.Component<Props> {
    public render() {
        const { component: Component, isLoggedIn, ...rest } = this.props;
        return (
            <Route { ...rest } render={(props) => (
                isLoggedIn === false
                    ? (Component ? <Component { ...props } /> : this.props.render && this.props.render(props))
                    : <Redirect to={{ pathname: Path.dashboard }} />
            )} />
        );
    }
}

const mapStateToProps = ({ auth }: ApplicationState) => {
    return {
        isLoggedIn: !!auth.user,
    };
};

export default connect(mapStateToProps)(GuestRoute);




// WEBPACK FOOTER //
// ./src/components/Routes/GuestRoute.tsx